import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-assign',
  templateUrl: './dialog-assign.component.html',
  styleUrls: ['./dialog-assign.component.css']
})
export class DialogAssignComponent {}
